import { AxiosError } from 'axios'

import type { ApiError, ToApiError } from '@/lib/apiError'
import { BadRequestError, GenericApiError, UnauthorisedError } from '@/lib/apiError'

export const toApiError: ToApiError = (error: unknown): ApiError => {
  if (error instanceof AxiosError) {
    const statusCode = error?.response?.status

    switch (statusCode) {
      case 400:
        return new BadRequestError([])

      case 401:
        return new UnauthorisedError()
    }

    return new GenericApiError()
  }

  return new GenericApiError()
}
